import { render } from "./ChatsList.vue?vue&type=template&id=e3c8f09e&scoped=true"
import script from "./ChatsList.vue?vue&type=script&lang=js"
export * from "./ChatsList.vue?vue&type=script&lang=js"

import "./ChatsList.vue?vue&type=style&index=0&id=e3c8f09e&scoped=true&lang=css"

import exportComponent from "/usr/app/workspace-stack/frontend-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3c8f09e"]])

export default __exports__